const ProductVideoUX = () => {
    document.addEventListener('DOMContentLoaded', function() {
        const deferredMediaElement = document.querySelector('deferred-media');
        
        if (deferredMediaElement) {
            // Try dispatching a 'load' event
            const loadEvent = new Event('load');
            deferredMediaElement.dispatchEvent(loadEvent);
            
            // If there's a load method, try invoking it
            if (typeof deferredMediaElement.load === 'function') {
                deferredMediaElement.load();
            }
    
            // Set the 'loaded' attribute to true
            deferredMediaElement.setAttribute('loaded', 'true');
        }
    });
}

export default ProductVideoUX